import { BaseApi } from './base.api.js';

export class RetentionPeriodApi extends BaseApi {
    constructor(client) {
        super(client, '/retention-period');
    }
}
